import DashboardLayout from '../components/Layout/DashboardLayout';
import MiniFooter from '../components/Layout/miniFooter';
import PaymentListener from '../components/payment/PaymentListener';
import AccountSettings from '../components/Settings/AccountSettings';
import WhatsAppChat from '../components/support/WhatsAppChat';

export default function SettingsPage() {
  return (
    <DashboardLayout>
      <PaymentListener />
      <div className="container mx-auto p-6">
        <h2 className="text-3xl font-extrabold text-gray-900 mb-8">Settings</h2>
        <AccountSettings />
      </div>
      <WhatsAppChat position='right' />
      <MiniFooter />
    </DashboardLayout>
  );
}